
import WidgetTwitter from '@/components/block/WidgetTwitter.vue'
import { defineComponent } from '@vue/runtime-core'

export default defineComponent({
  name: 'AdArea',

  components: {
    WidgetTwitter
  },

  setup() {
    const bannerList = [
      {
        link: '/guide',
        img: require('@/assets/images/home/footer_banner_guide.png'),
        alt: 'ご利用ガイド'
      },
      {
        link: '/contact/input',
        img: require('@/assets/images/home/footer_banner_contact.png'),
        alt: 'お問い合わせ'
      },
      {
        link: '/lp/services',
        img: require('@/assets/images/home/footer_banner_service.png'),
        alt: '医師向けサービスのご案内'
      },
      {
        link: '/lp/supporters',
        img: require('@/assets/images/home/footer_banner_supporters.png'),
        alt: '医学生サポーター大募集'
      },
      {
        link: '/lp/hpcr',
        img: require('@/assets/images/home/footer_banner_hpcr.jpg'),
        alt: 'ヒポクラ同時会員登録&ご利用ガイド'
      }
      // {
      //   link: '/lp/etc/newregist',
      //   img: require('@/assets/images/home/footer_banner_newregist.png'),
      //   alt:
      //     'マイナビRESIDENT 会員登録キャンペーン 会員登録するだけで全員に500円分のギフトコードプレゼント!'
      // }
    ]

    return {
      bannerList
    }
  }
})
